/* George Perfum — Pop-up de bienvenida: regístrate y obtén tu descuento */
(() => {
  'use strict';
  const root = document.querySelector('[data-gp-welcome]');
  if (!root || root.dataset.gpReady) return;
  root.dataset.gpReady = '1';

  const KEY = 'gpWelcome';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  const save = (o) => { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(read(), o))); } catch (e) {} };
  const dialog = root.querySelector('[data-gp-welcome-dialog]');
  const form = root.querySelector('form');
  const email = form && form.querySelector('input[type="email"]');
  const error = root.querySelector('[data-gp-welcome-error]');
  const submit = form && form.querySelector('[type="submit"]');
  const copyBtn = root.querySelector('[data-gp-welcome-copy]');
  let lastFocus = null;
  let state = 'form';

  function focusables() {
    return Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])'))
      .filter((el) => el.offsetParent !== null);
  }
  function setState(s) {
    state = s;
    root.dataset.state = s;
  }
  function open(mode) {
    if (root.classList.contains('is-open')) return;
    setState(mode || 'form');
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('gp-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
    window.setTimeout(() => {
      const target = state === 'success' ? root.querySelector('[data-panel="success"] h2') : email;
      if (target) target.focus({ preventScroll: true });
    }, 120);
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    if (state === 'form') save({ dismissed: Date.now() });
    root.classList.remove('is-open');
    document.documentElement.classList.remove('gp-lock');
    window.setTimeout(() => { root.hidden = true; }, 420);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function success() {
    save({ done: 1, pending: 0 });
    setState('success');
    const h = root.querySelector('[data-panel="success"] h2');
    if (h) window.setTimeout(() => h.focus({ preventScroll: true }), 60);
  }

  root.addEventListener('click', (e) => { if (e.target.closest('[data-gp-welcome-close]')) close(); });
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables();
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      error.textContent = '';
      if (!email.value || !email.checkValidity()) {
        error.textContent = 'Escribe un correo electrónico válido.';
        email.setAttribute('aria-invalid', 'true');
        email.focus();
        return;
      }
      email.removeAttribute('aria-invalid');
      submit.disabled = true;
      submit.classList.add('is-loading');
      save({ pending: 1 });
      try {
        const r = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
        const url = r.url || '';
        if (/challenge/.test(url)) { form.submit(); return; }
        const html = await r.text();
        if (/customer_posted=true/.test(url) || /customer_posted=true/.test(html)) { success(); }
        else if (r.ok && !/form__message[^>]*>[\s\S]{0,200}error/i.test(html) && !/errors/i.test(url)) { success(); }
        else { error.textContent = 'No pudimos registrar tu correo. Revísalo e inténtalo de nuevo.'; }
      } catch (err) {
        form.submit();
        return;
      } finally {
        submit.disabled = false;
        submit.classList.remove('is-loading');
      }
    });
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', async () => {
      const code = copyBtn.dataset.code;
      const label = copyBtn.querySelector('[data-gp-copy-label]');
      try {
        await navigator.clipboard.writeText(code);
        if (label) label.textContent = 'Copiado';
      } catch (e) {
        if (label) label.textContent = 'Mantén presionado para copiar';
      }
      window.setTimeout(() => { if (label) label.textContent = 'Copiar'; }, 2200);
    });
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-gp-welcome-open], a[href$="#bienvenida"]');
    if (!t) return;
    e.preventDefault();
    open(read().done ? 'success' : 'form');
  });

  // ¿Volvemos de un envío normal (con verificación)?
  const s = read();
  const params = new URLSearchParams(location.search);
  if (params.get('customer_posted') === 'true' && s.pending) {
    success();
    open('success');
    return;
  }

  const blocked = root.dataset.loggedIn === 'true' || s.done ||
    (s.dismissed && Date.now() - s.dismissed < 7 * 864e5) ||
    /\/(cart|checkout|account|challenge)/.test(location.pathname) ||
    window.Shopify && window.Shopify.designMode;
  if (blocked) return;
  let fired = false;
  const fire = () => {
    if (fired || document.querySelector('cart-drawer.active, .drawer.active, quick-add-modal[open]')) return;
    fired = true;
    open('form');
  };
  const delay = (parseFloat(root.dataset.delay) || 6) * 1000 + (document.documentElement.classList.contains('gp-intro') ? 2000 : 0);
  window.setTimeout(fire, delay);
  document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0) fire(); });
})();
